import React from 'react';
import { useStaffAuth } from '../../context/StaffAuthContext';
import { User, Mail, Phone, Building2, Shield } from 'lucide-react';

const ROLE_LABELS = {
  counter: 'Counter Staff',
  callcenter: 'Call Center',
  manager: 'Branch Manager',
};

export default function StaffProfile() {
  const { staff } = useStaffAuth();

  if (!staff) return null;

  const fields = [
    { icon: User, label: 'Name', value: staff.full_name },
    { icon: Mail, label: 'Email', value: staff.email },
    { icon: Phone, label: 'Phone', value: staff.phone || '—' },
    { icon: Shield, label: 'Role', value: ROLE_LABELS[staff.role] || staff.role },
    { icon: Building2, label: 'Branch', value: `${staff.branch_name || '—'}${staff.branch_city ? `, ${staff.branch_city}` : ''}` },
  ];

  return (
    <div className="p-6 max-w-lg mx-auto" data-testid="staff-profile">
      <h1 className="text-2xl font-bold text-[#1B375B] mb-6">Profile</h1>
      <div className="bg-white rounded-xl border divide-y">
        {fields.map(({ icon: Icon, label, value }) => (
          <div key={label} className="flex items-center gap-4 px-5 py-4">
            <Icon className="w-5 h-5 text-[#659A9B]" />
            <div>
              <p className="text-[10px] uppercase font-semibold text-gray-400">{label}</p>
              <p className="font-medium text-[#1B375B]">{value}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
